export default "__VITE_ASSET__2aa057d4__"